module.exports = __webpack_public_path__ + "355CC9_1_0.woff2?6d1355c450e98e097ec1fec461c25b26";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_1_0.woff2
// module id = 34
// module chunks = 0